export default __webpack_public_path__ + "static/one-6e606a91f6bbeb488064a6135ea3a417.webm";